"use client";

import React from "react";
import { HeartHandshake, Hammer, Users } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const coreValues = [{
  title: "Faith-Based Integrity",
  description: "Guiding our work with honesty, transparency, and a steadfast commitment to doing what is right for every family we serve.",
  icon: HeartHandshake
}, {
  title: "Uncompromising Craftsmanship",
  description: "Leveraging over 20 years of experience to deliver mid-range to luxury finishes with meticulous attention to every detail.",
  icon: Hammer
}, {
  title: "Family Focused",
  description: "A proud, family-owned business dedicated to building long-term relationships across Hudson, River Falls, Prescott, and Ellsworth.",
  icon: Users
}];
export default function OurCoreValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-core-values" className="relative py-24 lg:py-32 overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/soft_focus_construction_materials.png)] bg-cover bg-center opacity-40 blur-[2px]" aria-hidden="true" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/40 to-background/80" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div ref={ref} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground mb-6 tracking-tight">
            The Foundation of Our Work
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            At Finely Done, our approach to remodeling is built on a solid foundation of values that have guided us for over two decades.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {coreValues.map((value, i) => {
          const Icon = value.icon;
          return <Card key={i} data-index={i} className={`bg-card/60 backdrop-blur-md border-border/40 shadow-xl hover:shadow-2xl transition-all duration-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <CardHeader className="flex flex-col items-center text-center pb-4 pt-10">
                  <div className="mb-6 p-4 rounded-full bg-background/50 shadow-sm border border-border/30">
                    <Icon className="w-16 h-16 text-chart-2" strokeWidth={1} aria-hidden="true" />
                  </div>
                  <CardTitle className="text-2xl font-serif text-foreground">
                    {value.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center pb-10 px-8">
                  <p className="text-muted-foreground leading-relaxed">
                    {value.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}